import { render, staticRenderFns } from "./login-number-inside.vue?vue&type=template&id=108023c8&"
import script from "./login-number-inside.vue?vue&type=script&lang=js&"
export * from "./login-number-inside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports